import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class SharedService {
    // Observable string sources
    private emitLoading = new Subject<boolean>();
    private emitNotAuthorized = new Subject<boolean>();
    // Observable string streams
    loadEmitted$ = this.emitLoading.asObservable();
    unauthorizedEmitted$ = this.emitNotAuthorized.asObservable();
    // Service message commands
    emitLoad(enable: boolean) {
        this.emitLoading.next(enable);
    }
    emitUnauthorized() {
        this.emitNotAuthorized.next();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_services/shared.service.ts